import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';

function GenericCollapseWithChildren(props) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button className="collapse-toggle-btn btn text-btn" type="button" tabIndex="0" onClick={() => setIsOpen(!isOpen)}>
                {props.toggleJsx}
            </button>
            <Collapse isOpen={isOpen} role="region" tabIndex="0">
                {props.children}
            </Collapse>
        </>
    )
}

GenericCollapseWithChildren.propTypes = {
    toggleJsx: PropTypes.element.isRequired, // jsx user clicks to toggle the collapse open and closed
    children: PropTypes.node.isRequired, // children that will be shown when toggle is open
}

export default GenericCollapseWithChildren;